/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  contentPlaceholder : {
    '&&' : {
      backgroundColor : '#ebebeb',
      display         : 'block',
      overflow        : 'hidden',
      position        : 'relative',
      width           : '100%',
      height          : '100%'
    }
  },
  contentPlaceholderBackground : {
    animation  : '$contentPlaceholderAnimation 1s linear infinite',
    background : '-moz-linear-gradient(left, rgba(15,15,15,0) 0%, rgba(219,219,219,0.4) 50%, rgba(255,255,255,0) 100%)',
    /* @ts-ignore: allow duplicate property for safari webkit */
    background : '-webkit-linear-gradient(left, rgba(15,15,15,0) 0%,rgba(219,219,219,0.4) 50%,rgba(255,255,255,0) 100%)',
    /* @ts-ignore: allow duplicate property for safari webkit */
    background : 'linear-gradient(to right, rgba(15,15,15,0) 0%,rgba(219,219,219,0.4) 50%,rgba(255,255,255,0) 100%)',
    display    : 'block',
    height     : 'inherit',
    left       : '0',
    position   : 'absolute',
    top        : '0',
    width      : '70%',
    willChange : 'transform'
  },
  '@keyframes contentPlaceholderAnimation' : {
    '0%'   : {transform: 'translateX(-50%)'},
    '100%' : {transform: 'translateX(300%)'}
  }
}));

/**
 * @TombstoneLoader
 *
 * Placeholder component that takes up the entire height and width
 * of it's parent and presents an animated tombstone box.
 *
 * ```typescript
 * import {TombstoneLoader} from '@ion/dls/src/components/loading/TombstoneLoader';
 *
 * <TombstoneLoader />
 *
 * ```
 *
 */
export const TombstoneLoader = () => {
  const classes = useStyles();
  return (
    <div className={classes.contentPlaceholder}>
      <span className={classes.contentPlaceholderBackground} />
    </div>
  );
};

export default TombstoneLoader;
